import  { NavLink }  from "react-router-dom"
import  { Animate } from "react-simple-animate";

import 'remixicon/fonts/remixicon.css'
import {setWatchIsActive} from "../../../Features/Misc/navBarSlice";
import {activeMediaReset} from "../../../Features/Misc/activeSlice";

import {useDispatch} from "react-redux";

//redux functions

export default function NewNav() {
    const dispatch = useDispatch()

    const handleClick = () =>{
        dispatch(setWatchIsActive())
        dispatch(activeMediaReset())
    }

    return (
        <nav className="NewNav w-full col-start-1 col-end-13 grid grid-cols-12 grid-rows-2 row-start-1 row-end-3  ">

             <NavLink onClick={handleClick} className="p-4 col-start-2 col-end-12 row-start-1 row-end-2 flex items-center   justify-center text-3x2" to="/">
                 <Animate play start={{opacity: 0}} end={{opacity: 1}} duration={0.7} >
                    {/*<img  src="./KipMate_logo.svg" alt=""/>*/}
                     <img className="w-32"  src="https://www.kipmate.com/sortyourkip/client/build/kmlogo.svg" alt=""/>
                 </Animate>
             </NavLink>



            <ul className="flex col-start-2 col-end-12 row-start-2 row-end-3 text-2xl items-center justify-start px-4 col-span-2">
                <Animate play start={{opacity: 0}} end={{opacity: 1}} duration={0.7} >
                    <li className="text-white flex flex-row" >
                        <i className="ri-notification-line mr-4  text-pink-icon " />
                        <div>New</div>
                    </li>
                </Animate>
            </ul>
        </nav>

    );
}